export default __webpack_public_path__ + "static/media/netina-mission.0cd1d292.png";